import { ICellRendererParams } from "ag-grid-community";
import React, { useMemo } from "react";

import { OrganizationSummaryDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { BillingServiceBadge } from "@src/features/admin/components/Icons/BillingServiceBadge";
import { getBillingProviderFromAdminOrg } from "@src/features/admin/components/utils";

export const BillingProviderColumn = (
  params: ICellRendererParams<OrganizationSummaryDto>
) => {
  const service = useMemo(() => {
    return getBillingProviderFromAdminOrg(params.data);
  }, [params.data]);

  if (!params.data) {
    return null;
  }

  return (
    <Grid container columnSpacing={1} alignItems={"center"}>
      {service ? (
        <Grid item>
          <BillingServiceBadge
            service={service}
            deprecated={params.data.organizationSubscriptions.some((os) =>
              ["active", "pending"].includes(os.status)
            )}
          />
        </Grid>
      ) : null}
    </Grid>
  );
};
